import Favorites from "./favorites"
import GeneralHelper from "./generalHelper"
import View from "./View"
import ColorHelper from "./colorHelper"
import Pattern from "./pattern"
import MessageDictionary from "./MessageDictionary"
export default class EventSubscriber {

  static Subscribe() {

    let subscribedAlready = ( $('body').attr('class') && $('body').attr('class').indexOf('eventsBound') > -1 )  ;
    if (! subscribedAlready )
    {
      $('body').addClass('eventsBound');
      $('body').unbind('click').on('click', '.check-logged-in', function(e) {
        if ( ! $(this)[0].disabled )
        {
          if ( ! GeneralHelper.is_user_logged_in() )
          {
            if ( parent && parent.postMessage )
            {
              parent.postMessage(JSON.stringify({ sender : $(this)[0].id, type: "REQUEST_CREDENTIALS" }), "*");
            }
            return false ;
          }
          else {
            parent.postMessage(JSON.stringify({ sender : $(this)[0].id, type: "USER_ALREADY_LOGGED_IN" }),  "*");
            if ($(this)[0].id == 'view-favorites' )
            {
              window.Favorites.hideEmptyFavMessage(false);
              window.Favorites.reload_favorites$('');
            } 
            else if ($(this)[0].id == 'add-to-cart' )
            {
              window.PatternBuilderCart.addToCart();
            }
            else if ( $(this)[0].id == 'add-to-favorites')
            {
              var tuple = null;
              var doc_id = window.AppInstance.instance().selected.ExternalId ;
              if (!window.AppInstance.instance().is_raster)
                tuple = JSON.stringify(ColorHelper.get_swatches_spotcolor_tuples(window.AppInstance.instance().canvas.figures[0])) ;
              else
                tuple  = window.AppInstance.instance().selected.ExternalId ;
                Favorites.add_tuple$(window.AppInstance.instance().selected.ExternalParentID, tuple).then(function(fav) {
                  $("#add-to-favorites").html('Add '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination to Favorites');
                  Favorites.refresh$(window.AppInstance.instance().selected.ExternalParentID).then(function() {
                    let item = window.AppInstance.instance().is_raster ? tuple : GeneralHelper.sanitize_GID(window.AppInstance.instance().selected.ExternalParentID) ;
                    let variation = window.AppInstance.instance().is_raster ? null : JSON.parse(tuple) ;
                    let config = GeneralHelper.sanitize_GID(fav.Id) ;
                    Favorites.add_single_item(item.replace("production-", ""), variation, config).then(function(item) {
                      Favorites.reload_tuples$( window.AppInstance.instance().selected.ExternalParentID, 'pattern-favorite-sets' ).then(function() {
                        $("#noPatternMessage").hide();
                        View.toggle_favorites_button();
                      });
                      // $('#pattern-favorite-sets').append(item);
                      // $("#noPatternMessage").hide();
                      // View.toggle_favorites_button();
                    });
                  });
                }
              , function() {
                  GeneralHelper.open_general_box({
                    templateName: "info_modal",
                    heading: "ERROR",
                    content: "<p>Favorite has already been added</p>",
                    buttons: "<a class='orangeButton' onclick='MY METHOD HERE'>OK</a>"
                  });
                  $("#add-to-favorites").html('Add '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination to Favorites');
              });
            }
            else if ( $(this)[0].classList.contains('icon-favorites-heart-outline') || $(this)[0].classList.contains('icon-favorites-heart-solid') )
            {
              Favorites.AddDocToFavs($(this)[0]);
            }
            else if ( $(this)[0].classList.contains('delete-favorite') )
            {
              var me = this ;
              GeneralHelper.open_general_box({
                templateName: "info_modal",
                heading: "DELETE",
                content: "<p>Are you sure you want to remove this "+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+" combination from favorites?</p>",
                buttons: "<a class='whiteButton' onclick='$.colorbox.close();'>CANCEL</a> <a id='DeleteModalBtn' class='orangeButton'>OK</a>",
                target: 'DeleteModalBtn'
              }, function() {
                $("#DeleteModalBtn").click(function() {
                  Favorites.remove_tuple$($(me).data('id'), window.AppInstance.instance().selected.ExternalParentID).then(function() {
                    Favorites.reset_tuples();
                    Favorites.refresh$(window.AppInstance.instance().selected.ExternalParentID).then(function(){
                      $(me).parent().hide();
                      $.colorbox.close();
                    })
                    .catch(function(e) {
                      GeneralHelper.errorOut(e);
                    });
                  });
                })
              });
            }
            else if ( $(this)[0].classList.contains('delete-favorite-search') )
            {
              var me = this ;
              GeneralHelper.open_general_box({
                templateName: "info_modal",
                heading: "DELETE",
                content: "<p>Are you sure you want to remove this pattern from favorites?</p>",
                buttons: "<a class='whiteButton' onclick='$.colorbox.close();'>CANCEL</a> <a id='DeleteFavoriteModalBtn' class='orangeButton'>OK</a>",
                target: 'DeleteFavoriteModalBtn'
              }, function() {
                $("#DeleteFavoriteModalBtn").click(function() {
                  Favorites.remove_document$($(me).data('id'), $(me).data('external')).then(function() {
                    Favorites.delete_documents_container('/docs/' + window.AppInstance.instance().CUSTOMER_HASH);
                    Favorites.reload_favorites$();
                    $.colorbox.close();
                  });
                });
              });
            }
            return true ;
          }
        }
      });

      // $('#tabs ul').click(function() {
      //   alert();
      // });

      $('#download-button').click(function() {

        const downloadFile = (blob, fileName) => {
          const link = document.createElement('a');
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          setTimeout(() => URL.revokeObjectURL(link.href), 7000);
        };
        
        if (window.AppInstance.instance().selected !== undefined )
        {
          View.wizardLoading(true, true, true);
          Pattern.get_export_document_link$()
          .then(function(url) {
            document.getElementById('download_frame').src = url;
            View.wizardLoading(true, true, false);
          })
        }
      });

      $('#export-async-button').click(function() { 
          function checkJob(ident, jobId) {
            let processing = true
            let count = 0

            Pattern.checkExportPatternBuilderJob$( ident, jobId )
            .then((checkRes)=>{
              if ( checkRes.Model.Status !== "Processing" ) {
                processing = false
                console.log( JSON.stringify(checkRes, null, 2) )
              } else {
                console.log( "waiting...", count++ )
                setTimeout( () => { checkJob(ident, jobId ) }, 1500 );            
              }
            })
          }       
          Pattern.exportPatternBuilderJob$(PatternBuilderCart.jobData)
          .then((exportRes)=>{
            const jobId = exportRes?.Model.Id
            checkJob(exportReq.ident, jobId); 
          })
      });

      //add document to favorite
      $('body').on('click', '.icon-favorite-alt, .icon-favorite',  function() {
        var p = $(this);
        var el = p[0];
        var is_fav = Boolean($(this).data('fav'));
        el.setAttribute('class', '');
        if (is_fav)
        {
          Favorites.remove_document$($(this).data('id'), $(this).data('external')).then(function() {
            el.setAttribute('class', 'icon-favorite');
            p.data('fav', false);
            Favorites.get_favorite_documents$().then(function(favs) {
              window.AppInstance.instance().favorites = favs.Items ;
            })
            .catch(function(e) {
              GeneralHelper.errorOut(e);
            });
          });
        }
        else{
          Favorites.add_document$($(this).data('id')).then(function() {
            el.setAttribute('class', 'icon-favorite-alt');
            p.data('fav', true);
            Favorites.get_favorite_documents$().then(function(favs) {
              window.AppInstance.instance().favorites = favs.Items ;
            })
            .catch(function(e) {
              GeneralHelper.errorOut(e);
            });
          });
        }
      });

      //Select favorite (inside pattern detail)
      $('body').on('click', '.select-favorite', function() {
        var selected = $(this).data('id') ;
        Favorites.load_tuples$().then(function(r){
          if ( r.Items.length > 0 )
          {
            var s = Cx_.filter(r.Items, function(i) { return ( i.Id === selected )})[0];
            if ( s != undefined )
            {
              var data = JSON.parse(s.Data);
              if ( window.AppInstance.instance().is_raster )
                window.load_pattern_and_metafiles(data.tuple, false);
              else
                window.update_pickers(ColorHelper.tuples_to_swatch_array(JSON.parse(data.tuple)));
            }
          }
        })
        .catch(function(e) {
          GeneralHelper.errorOut(e);
        });
      });

      $('.icon-zoom-in-magnify-glass').click(function () {
        var zoom = parseFloat(window.AppInstance.instance().canvas.zoom) + 0.1;
        if ( zoom <= window.AppInstance.instance().max_zoom_level) {
          window.AppInstance.instance().canvas.zoom = zoom;
          window.AppInstance.instance().rulerX.drawBar();
          window.AppInstance.instance().rulerY.drawBar();
          GeneralHelper.zoom_bar_set(zoom);
          window.AppInstance.instance().canvas.render$();
        }
      });

      $('.icon-zoom-out-magnify-glass').click(function () {
        var zoom = parseFloat(window.AppInstance.instance().canvas.zoom) - 0.1;
        if ( zoom >= window.AppInstance.instance().min_zoom_level) {
          window.AppInstance.instance().canvas.zoom = zoom;
          window.AppInstance.instance().rulerX.drawBar();
          window.AppInstance.instance().rulerY.drawBar();
          GeneralHelper.zoom_bar_set(zoom);
          window.AppInstance.instance().canvas.render$();
        }
      });

      $('.icon-refresh').click(function () {
        if ( window.AppInstance.instance().selected !== undefined )
        {
          window.AppInstance.instance().canvas.resetToOrigin();
          window.AppInstance.instance().canvas.zoom = window.AppInstance.instance().selected.metadata.get("canvasZoom") ;
          window.AppInstance.instance().rulerX.drawBar();
          window.AppInstance.instance().rulerY.drawBar();
          GeneralHelper.zoom_bar_set(window.AppInstance.instance().canvas.zoom);
          window.AppInstance.instance().canvas.render$();
        }
      });

      $("#pattern-default-sets").on("click", ".colorway", function() {
        $("#pattern-default-sets .colorway").removeClass("active");
        $(this).addClass("active");
        window.AppInstance.instance().selected.thumb_url = $(this).find('img')[0].src ;
      });

      $('.orangeButton').on('click', function(el) {
        if ( $('#'+$(this)[0].getAttribute('step') ) )
          $('.'+$(this)[0].getAttribute('step')+'-link').click();
      });
    }
  }

  static SubscribeCart() {

      $(".item-qty input.total-yardage").bind('input',  PatternBuilderCart.updateQuantitiesFromTotal );

      $("input.numbers-only").on("keyup change", function(e) {
        var keynum, keychar, numcheck;
  
        if (e.which) { // Netscape/Firefox/Opera
          keynum = e.which;
        } else {      // ie and occasionally
          keynum = e.keyCode;
        }
  
        keychar = String.fromCharCode(keynum);
  
        if (keynum == 8 ||
          keynum == 9 || /* tab */
          keynum == 13 /* enter */) {  // backspace, delete, arrow keys...
          return true;
        }
  
        numcheck = /\d/;
  
        return numcheck.test(keychar);
      });
  
      $("input.numbers-only").on("input", function(e) {
        this.value = this.value.replace(/[^0-9]/g,'');
      });
  
      $(".item-qty input.uofm").on("input", function() {
        window.PatternBuilderCart.updateTotalFromQuantities($(this).closest(".wiz-row"));
        window.PatternBuilderCart.getTotalPricing();
      });
  }
}


